import { useForwardExpose } from "../shared/useForwardExpose.js";
import { MenuLabel_default } from "../Menu/MenuLabel.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/ContextMenu/ContextMenuLabel.vue?vue&type=script&setup=true&lang.ts
var ContextMenuLabel_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenuLabel",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		useForwardExpose();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(MenuLabel_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/ContextMenu/ContextMenuLabel.vue
var ContextMenuLabel_default = ContextMenuLabel_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { ContextMenuLabel_default };
//# sourceMappingURL=ContextMenuLabel.js.map